import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as ProjectsV2Store from '../../../../redux/projectsV2';
import BulkSelectionBanner from '../../../generic/BulkSelectionBanner';
import { ProjectCategory } from '../../../../../shared/projectsV2/common';

/**
 * ProjectsBulkSelectionBanner displays the number of selected projects,
 * and gives the user the option to select "all" across all pages.
 */
const ProjectsBulkSelectionBanner: VoidFunctionComponent = () => {
  //  State selectors
  const category = useSelector(ProjectsV2Store.selectors.getCategory);
  const count = useSelector(ProjectsV2Store.selectors.getProjectsOnPageCount);
  const areAllProjectsSelected = useSelector(ProjectsV2Store.selectors.getAreAllProjectsSelected);
  const totalProjectsCount = useSelector(ProjectsV2Store.selectors.getTotalProjects);
  const isEveryProjectOnPageSelected = useSelector(ProjectsV2Store.selectors.getIsEveryProjectOnPageSelected);

  const shouldShowShowBanner = isEveryProjectOnPageSelected || areAllProjectsSelected;

  //  Handlers:
  const dispatch = useDispatch();
  const onSelectAllProjects = () => dispatch(ProjectsV2Store.actions.selectAllProjects());
  const onClearSelection = () => dispatch(ProjectsV2Store.actions.clearSelection());

  return shouldShowShowBanner ? (
    <BulkSelectionBanner
      itemsNoun={category === ProjectCategory.ReleaseGroups ? 'release group' : 'project'}
      pageSize={count}
      totalItemsCount={totalProjectsCount ?? 0}
      areAllItemsSelected={areAllProjectsSelected}
      sectionName={category === ProjectCategory.ReleaseGroups ? 'Release Groups' : 'Projects'}
      onSelectAll={onSelectAllProjects}
      onClearSelection={onClearSelection}
    />
  ) : null;
};

export default ProjectsBulkSelectionBanner;
